import { type TextImageOverlayBlock as TextImageOverlayBlockType } from '../../../types/graphql.page.ts'
import TextImageOverlayBlock from './textImageOverlayBlock.tsx'

export default function PortfolioListingBlock({
	status,
	block,
}: {
	status: boolean
	block: TextImageOverlayBlockType
}) {
	const updatedBlock = status
		? block
		: {
				...block,
				text: `${block.text}
<h6><em><strong>Exited Investment</strong></em></h6>`,
			}
	return (
		<TextImageOverlayBlock
			isPortfolio={true}
			className="portfolio mt-0"
			block={updatedBlock}
		/>
	)
}
